var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Size=32px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.9998 21.3333C18.9454 21.3333 21.3332 18.9455 21.3332 16C21.3332 13.0545 18.9454 10.6667 15.9998 10.6667C13.0543 10.6667 10.6665 13.0545 10.6665 16C10.6665 18.9455 13.0543 21.3333 15.9998 21.3333Z",
    stroke: "#1E1E20",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.3332 10.6667V17.3333C21.3332 18.3942 21.7546 19.4116 22.5048 20.1617C23.2549 20.9119 24.2723 21.3333 25.3332 21.3333C26.3941 21.3333 27.4115 20.9119 28.1616 20.1617C28.9118 19.4116 29.3332 18.3942 29.3332 17.3333V16C29.333 12.9907 28.3148 10.07 26.4442 7.71269C24.5736 5.35543 21.9606 3.70029 19.03 3.01638C16.0995 2.33248 13.0238 2.66004 10.303 3.94581C7.5822 5.23158 5.37638 7.39993 4.04419 10.0983C2.71201 12.7966 2.3318 15.8663 2.96541 18.8081C3.59901 21.75 5.20915 24.391 7.53402 26.3017C9.85889 28.2124 12.7618 29.2805 15.7706 29.3322C18.7795 29.3839 21.7173 28.4163 24.1065 26.5867",
    stroke: "#1E1E20",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtIcon);
export default __webpack_public_path__ + "static/media/atIcon.47211ae45ad38fa7d654a78a3ff510e2.svg";
export { ForwardRef as ReactComponent };